import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MOperationsModule } from '@mining/ui/operations';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import { MFooterOperationsBarComponent } from './footer-operations-bar.component';
@NgModule({
  imports: [CommonModule, NzOutletModule, MOperationsModule],
  exports: [MFooterOperationsBarComponent],
  declarations: [MFooterOperationsBarComponent]
})
export class MFooterOperationsBarModule {}
